import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('GET_VISIBILTY'),
  ...asyncTypes('UPDATE_VISIBILTY')
};

export default TYPES;
